import React, {Component} from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import * as moment from "moment";
import NotificationSystem from "react-notification-system";
import {connect} from "react-redux";
import {style} from "variables/Variables.jsx";
import {isApiResponse, date_range_config} from '../helpers/utils.js';
import MultiCsvReportDownload from '../components/DownloadReport/MultiCsvReportDownload.jsx';
import MerchantFilter from '../filters/MerchantFilter.jsx';
import StoreFilter from '../filters/StoreFilter.jsx';
import DateRangeFilter from '../filters/DateRangeFilter.jsx';
import CityFilter from '../filters/CityFilter.jsx';
import ProductTypeFilter from '../filters/ProductTypeFilter.jsx';
import OpenTicketIssueSubCategory from '../filters/OpenTicketIssueSubCategory.jsx';
import ChannelNameFilter from '../filters/ChannelNameFilter.jsx';
import TeamMemberNameFilter from '../filters/TeamMemberNameFilter.jsx';
import TeamNameFilter from '../filters/TeamNameFilter.jsx';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import MerchantTab from './MerchantTab.jsx';
const diff = new Date().getDate() - 1;
var date_config = date_range_config(diff, '0', '2020-02-01','0');

class QCAgentPerformance extends Component{
    constructor(props) {
        super(props);
        this.state = {
            datefrom: date_config.start_date,
            dateTo: date_config.end_date,
            datefromShow: date_config.display_start_date,
            dateToShow: date_config.display_end_date,
            yestSend: date_config.start_date_value,
            todSend: date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit: date_config.end_date_limit,
            merchantID: '',
            chainID: '',
            storeID: '',
            merchantValue: null,
            chainValue: null,
            storeValue: [],
            ciutidIds: '',
            object_code: [],
            issue_type: "",
            cf_issue_sub_category: "",
            selected_tab: 'Assign Urgent Beat Plan',
            isChange: false,
            ticket_id: '',
            cf_utid: '',
            beat_plan_date: null,
            model_visible: false,
            is_submit_disable: true,
            cf_merchant_contact_number: ""
        }
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1: level = "success"; break;
            case 2: level = "warning"; break;
            case 3: level = "error"; break;
            case 4: level = "info"; break;
            default: break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (<div>{msg}</div>),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        if(decoded.object_type === 'Merchant'){
            this.setState({merchantID: arrayCode})
        }
        if(decoded.object_type === 'Chain'){
            this.setState({chainID: arrayCode})
        }
        if(decoded.object_type === 'Store'){
            this.setState({storeID: arrayCode})
        }

        this.setState({
            user_id: decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
            email: decoded.email
        });
    }

    componentDidMount() {

        this.setState({ _notificationSystem: this.refs.notificationSystem });

    }



    TicketDownloadCheck(type, e){
        var fn = '';
        var url = '';
        var report_code = '';


        let filters = {

        }

        this.setState({filters: filters})
        this.refs.downloadAllReport.downLoadReport(filters, url, fn, 60);
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date, date_config.end_date, date_config.display_start_date, date_config.display_end_date, date_config.start_date_value, date_config.end_date_value);

        if(this.state.object_type === 'Innoviti') {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false, '');
            this.refs.reloadUtid.ci_utid('', '', '', false, '');
        }
        if(this.state.object_type === 'Merchant') {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code, false, '');
            this.refs.reloadUtid.ci_utid(this.state.object_code, '', '', false, '');
        }
        if(this.state.object_type === 'Chain') {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code, false, '');
            this.refs.reloadUtid.ci_utid('', this.state.object_code, '', false, '');
        }
        if(this.state.object_type === 'Store') {
            this.refs.reloadUtid.ci_utid('', '', this.state.object_code, false, '');
        }

        this.refs.OpenTicketIssueSubCategoryFilter.restOpenTicketIssueSubCategoryFilter();

        this.setState({
            datefrom: date_config.start_date,
            dateTo: date_config.end_date,
            datefromShow: date_config.display_start_date,
            dateToShow: date_config.display_end_date,
            yestSend: date_config.start_date_value,
            todSend: date_config.end_date_value,
            merchantID: '',
            chainID: '',
            storeID: '',
            storeValue: [],
            merchantValue: [],
            chainValue: [],
            ciutidIds: '',
            isChange: false,
            issue_type: "",
            cf_issue_sub_category: "",
            cf_merchant_contact_number: ""
        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }

    handleDateRange = (todSend, yestSend, datefromShow, dateToShow) => {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }

    handleMerchant = (optionSelected, merchantID) => {
        this.setState({
            merchantID: merchantID,
            isChange: true,
            chainID: '',
            storeID: '',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code, false, '');
        this.refs.reloadUtid.ci_utid(merchantID, '', '', false, '');
    }

    handleChain = (optionSelected, chainID) => {
        this.setState({
            chainID: chainID,
            isChange: true,
            storeID: '',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID, false, '');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID, '', false, '');
    }

    handleStore = (storeID) => {
        this.setState({
            storeID: storeID,
            isChange: true,
            ciutidIds: '',
        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID, storeID, false, '');
    }

    handleOpenTicketIssueSubCategory = (optionSelected, cf_issue_sub_category) => {
        this.setState({
            cf_issue_sub_category: cf_issue_sub_category,
            isChange: true
        });
    }

    handleDownload = (reportType) => {
        this.TicketDownloadCheck(reportType);
    }

    get_selected_tab(object_type, object_code, selected_tab, event){
        if(selected_tab === 'Assign Urgent Beat Plan'){
            this.setState({
                show_acq_issuer: false,
                selected_tab: selected_tab
            })
            setTimeout(function(){
                this.get_tickets(object_type, object_code, event);
            }.bind(this), 200);
        } else {
            this.setState({
                show_acq_issuer: true,
                selected_tab: selected_tab
            })
//             setTimeout(function(){
//                 this.get_urgent_assignment(object_type, object_code, event);
//             }.bind(this), 200);
        }
    }

    render() {
        return(
            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">QC Agent Performance Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        <div className="report-header-icons">
                                            <div className="icon-button refresh-icon" title="Refresh Report">
                                                <i className="fa fa-refresh"></i>
                                            </div>
                                            <div className="icon-button print-icon"  title="Print Report">
                                                <i className="fa fa-print"></i>
                                            </div>
                                            <div className="icon-button email-icon"  title="Email Report">
                                                <i className="fa fa-envelope"></i>
                                            </div>
                                            <div className="icon-button download-icon"  title="Download Report">
                                                <i className="fa fa-download"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className = "clearfix"></div>

                                <div className="content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Ticket Logged Date: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow} start_date_limit = {this.state.dateFromLimit} />
                                            </div>

                                            {this.state.object_type === 'Innoviti' ?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}

                                            {this.state.object_type === 'Innoviti' || this.state.object_type === 'Merchant' ?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Issue Category </label>
                                                    <OpenTicketIssueSubCategory ref="OpenTicketIssueSubCategoryFilter" onSelectOpenTicketIssueSubCategory = {this.handleOpenTicketIssueSubCategory} />
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> City: </label>
                                                <CityFilter ref="cityFilter" onSelectCity = {this.handleCity}/>
                                                <div className="clearfix"></div>
                                            </div>

                                            {this.state.object_type === 'Innoviti' || this.state.object_type === 'Merchant' || this.state.object_type === 'Chain' ?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Team Name</label>
                                                <TeamNameFilter />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Team Member Name</label>
                                                <TeamMemberNameFilter />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Channel</label>
                                                <ChannelNameFilter />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Product Type </label>
                                                <ProductTypeFilter ref="productTypeFilter" onSelectProduct = {this.handleProduct} userType={this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange === true ?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_selected_tab.bind(this, this.state.object_type,this.state.object_code, this.state.selected_tab)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <Tabs>
                                            <TabList>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Merchant Name','')}>Merchant Name</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Issue Category','')}>Issue Category</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Team Name','')}>Team Name</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Team Member Name','')}>Team Member Name</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Channel','')}>Channel</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Product','')}>Product</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'City','')}>City</Tab>
                                            </TabList>

                                            <TabPanel>
                                                <MerchantTab
                                                    merchantID={this.state.merchantID}
                                                    chainID={this.state.chainID}
                                                    storeID={this.state.storeID}
                                                    yestSend={this.state.yestSend}
                                                    todSend={this.state.todSend}
                                                    ciutidIds={this.state.ciutidIds}
                                                    issue_type={this.state.issue_type}
                                                    cf_issue_sub_category={this.state.cf_issue_sub_category}
                                                    cf_merchant_contact_number={this.state.cf_merchant_contact_number}
                                                    object_type={this.state.object_type}
                                                    object_code={this.state.object_code}
                                                    user_id={this.state.user_id}
                                                    onDownload={this.handleDownload}
                                                />
                                            </TabPanel>

                                            <TabPanel>

                                            </TabPanel>

                                            <TabPanel>

                                            </TabPanel>

                                            <TabPanel>

                                            </TabPanel>

                                            <TabPanel>

                                            </TabPanel>

                                            <TabPanel>

                                            </TabPanel>

                                            <TabPanel>
                                            </TabPanel>
                                        </Tabs>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        currentMenu: (name) => {dispatch({type:'change_menu',payload:name})}
    }
}

export default connect(null, mapDispatchToProps)(QCAgentPerformance);